const VUE_APP_DEV_API_URL = process.env.VUE_APP_DEV_API_URL;
let apiUrl = process.env.VUE_APP_API_URL;

if (process.env.NODE_ENV === "development") {
    apiUrl = VUE_APP_DEV_API_URL;
}
export const API_URL = apiUrl;
